module.exports = __webpack_public_path__ + "img/slide_4.d43b5da3.jpg";